<template>
  <div class="p-ds-screen-info">
    <el-input placeholder="搜索任务"
              prefix-icon="el-icon-search"
              :clearable="true"
              @clear="handleClearValue"
              v-model="searchValue"
              @keyup.enter.native="handleSearchContent"
    />
  </div>
</template>
<script>
export default {
  name: 'SearchValue',
  data () {
    return {
      searchValue: '',
      timer: ''
    }
  },
  methods: {
    handleSearchContent () {
      if (this.timer) clearTimeout(this.timer)

      this.timer = setTimeout(() => {
        this.emit(this.searchValue)
      }, 300)
    },
    handleClearValue () {
      this.emit('')
    },
    emit (opt) {
      this.$emit('keyUp', opt)
    }
  }
}
</script>
<style scoped>
  .p-ds-screen-info {
    margin-left: 20px;
    display: flex;
    align-items: center;
    position: absolute;
    right: 60px;
    height: 32px;
    width: 180px;
  }

  .p-ds-screen-info >>> .el-input,
  .p-ds-screen-info >>> .el-input__inner {
    border-radius: 20px;
    overflow: hidden;
    height: 32px;
    width: 180px;
  }

  .p-ds-screen-info >>> .el-input__inner:focus {
    border-color: #DCDFE6;
  }
  .p-ds-screen-info >>> .el-input__prefix {
    top: -4px;
  }

</style>
